module.exports = __webpack_public_path__ + "static/media/13-Mayfair.bfca1c8f.mp4";